import React, { useState } from 'react';
import '../styles/NewVersionBar.css';

const SEEN_KEY = 'tm_release_seen';

// `?whatsnew` in the URL brings the bar back after it was dismissed — for testing it.
function readSeen() {
  try {
    if (new URLSearchParams(window.location.search).has('whatsnew')) {
      localStorage.removeItem(SEEN_KEY);
      return null;
    }
    return localStorage.getItem(SEEN_KEY);
  } catch { return null; }
}

function writeSeen(version) {
  try { localStorage.setItem(SEEN_KEY, version); } catch { /* private mode: bar returns next login */ }
}

/**
 * Banner shown on every login until the user opens the release notes or clicks
 * "Don't show again". Either action records the version, so it stays hidden until
 * the next release. Closing the tab without acting leaves it to show again.
 */
function NewVersionBar({ version, onOpenReleaseNotes }) {
  const [seen, setSeen] = useState(readSeen);
  if (!version || seen === version) return null;

  const dismiss = () => { writeSeen(version); setSeen(version); };

  return (
    <div className="new-version-bar" role="status">
      <span className="new-version-bar-text">
        🎉 A new version is available (v{version}).{' '}
        <button
          type="button"
          className="new-version-bar-link"
          onClick={() => { dismiss(); onOpenReleaseNotes(); }}
        >
          See what's new
        </button>
      </span>
      <button type="button" className="new-version-bar-dismiss" onClick={dismiss}>
        Don't show again
      </button>
    </div>
  );
}

export default NewVersionBar;
